// extracted by mini-css-extract-plugin
export default {"label":"RadioGroup_label__5CYRT","radio":"RadioGroup_radio__7B4Eb","error":"RadioGroup_error__dn6wu"};